import React, {lazy, useEffect, useRef, useState} from "react";
import ConditionalWrapper from "../../utils/ConditionalWrapper";
import HighlightSearchTerm from "../../utils/highlightSearchTerm";
import RequestService from "../../utils/fetch";
import {endPointsGeoSearch} from "../../utils/Endpoints";

const AutosizeInput = lazy(() => import("../../utils/AutosizeInput"));

const Input = React.forwardRef((props, ref) => {

    const {...inputProps} = props;

    // TODO: Refactor
    if (inputProps.setJobagentObject) {
        delete inputProps.setJobagentObject;
    }
    // TODO: Refactor
    if (inputProps.type === "input") {
        delete inputProps.type;
    }
    const [showResults, setShowResults] = useState(false);
    const configName = "myTalentionConfig";
    const [configObject, setConfigObject] = useState(window[configName]);
    const [autocomplete, setAutocomplete] = useState(null);
    const [highlightedItem, setHighlightedItem] = useState(-1);
    const [listOfCities, setListOfCities] = useState(-1);
    const [input, setInput] = useState(null);
    const [currentValue, setCurrentValue] = useState(null);
    const suppressAutocompleteRef = useRef(false); // einmalige Unterdrückung nach Auswahl
    const [city, setCity] = useState("");
    const filterElementWrapper = useRef(undefined);

    function handleGeoSearch(geoValue) {
        console.log("geoValue", geoValue);
    }

    useEffect(() => {
        console.log(highlightedItem, "highlightedItem");
    }, [highlightedItem]);

    useEffect(() => {
        if (input !== null) {

            if (myTalentionConfig.geosearch?.version === 2) {
                return;
            }

            // just  for google

            const componentRestrictions = myTalentionConfig.geosearch?.componentRestrictions || {country: ["de"]};
            const options = {
                types: ["(cities)"],
                componentRestrictions,
            };
            if (autocomplete === null) {
                setAutocomplete(new google.maps.places.Autocomplete(input, options));
            }
        }

    }, [input]);
    const handleGeocode = (response) => {

        RequestService.getRequest(`${configObject.clientURL}${endPointsGeoSearch.city}?city=${response.city}&language=de&key=${configObject.geosearch.key}`).then(data => {
            props.setJobagentObject((oldJobagent) => {
                return {
                    ...oldJobagent,
                    search: {
                        ...oldJobagent.search,
                        filter: {
                            ...oldJobagent.search.filter,
                            geoLocation: {
                                lat: data.latitude,
                                lng: data.longitude,
                                radius: window.myTalentionConfig.jobagentRadius || 80,
                                label: data.city,
                            }
                        }
                    }
                };
            });
            // Wichtig: nach programmgesteuerter Auswahl Autocomplete einmalig unterdrücken
            suppressAutocompleteRef.current = true;
            if (typeof inputProps.onChange === "function") {

                if (inputProps.registerObject?.customProperties?.[inputProps.name]?.length) {
                    inputProps.onChange({value: `${response.city}, ${response.country}`}, inputProps);
                } else {


                    inputProps.onChange({value: `${response.city}, ${response.country}`}, inputProps);
                    // console.log(inputProps.onChange("WUppertal"));
                }
            }
            closeMenu();
        });
    };


    useEffect(() => {


        if (inputProps.registerObject === undefined) {
            return;
        }

        const {customProperties} = inputProps.registerObject;


        if (customProperties[inputProps.name] === undefined) {
            return;
        }

        if (currentValue === customProperties[inputProps.name]) {
            return;
        }
        setCurrentValue(customProperties[inputProps.name]);


        if (configObject.geosearch?.active === false) {
            return;
        }

        if (configObject.geosearch?.version !== 2) {
            return;
        }

        if (inputProps.places === undefined) {
            return;
        }
        if (inputProps.registerObject === undefined) {
            return;
        }

        if (inputProps.registerObject.customProperties[inputProps.name] === undefined) {
            return;
        }
        if (inputProps.registerObject.customProperties[inputProps.name].length === 0) {
            return;
        }

        if (inputProps.registerObject?.search?.geoLocation?.label === city) {
            return;
        }

        // Wenn der Wert programmgesteuert gesetzt wurde, diese Runde überspringen
        if (suppressAutocompleteRef.current) {
            suppressAutocompleteRef.current = false;
            return;
        }


        if (inputProps.registerObject?.customProperties?.[inputProps.name]?.length) {

            RequestService.postRequest(`${configObject.clientURL}${endPointsGeoSearch.autocomplete}`, {
                value: inputProps.registerObject.customProperties[inputProps.name],
                key: configObject.geosearch.key,
                locale: configObject.lang || "de",
                componentRestrictions: configObject.geosearch.componentRestrictions || {country: ["de", "at", "ch"]},
            }).then((data) => {

                if (data) {
                    setListOfCities(data);
                    setShowResults(true);
                }
            });
        } else {

            if (inputProps.value.length === 0) {
                return;
            }

            RequestService.postRequest(`${configObject.clientURL}${endPointsGeoSearch.autocomplete}`, {
                value: inputProps.value,
                key: configObject.geosearch.key,
                locale: configObject.lang || "de",
                componentRestrictions: configObject.geosearch.componentRestrictions || {country: ["de", "at", "ch"]},
            }).then((data) => {

                if (data) {
                    setListOfCities(data);
                    setShowResults(true);
                }
            });

        }


    }, [inputProps.registerObject, inputProps.value]);
    const handleClickOutside = (event) => {


        if (filterElementWrapper.current === undefined || filterElementWrapper.current === null) {
            return;
        }
        if (filterElementWrapper.current.contains(event.target)) {
            return;
        }

        closeMenu();

    };
    const handleHideDropdown = (event) => {
        if (event.key === "Escape") {
            closeMenu();
        }

        /** TAB **/
        if (event.key === "Tab") {
            closeMenu();
        }
    };
    const closeMenu = () => {
        setShowResults(false);
        setHighlightedItem(-1);

    };
    // const handleArrowMovement = (direction, event = false) => {
    //     const itemsCount = document.querySelectorAll(".tms-geosearch-city-list-item").length;
    //
    //     if (listOfCities.length === 0) {
    //         return false;
    //     }
    //     if (direction === "up") { // up
    //
    //         if (highlightedItem === 0) { // end of list
    //             return false;
    //         }
    //
    //         setHighlightedItem(item => item - 1);
    //         // document.querySelector(".tms-select-replacement-search .tms-is-highlighted + li")
    //         //     .scrollIntoView({
    //         //         block: "nearest",
    //         //     });
    //     }
    //
    //     if (direction === "down") { // up
    //
    //         if (itemsCount === listOfCities.length - 1) { // end of list // -1 cause index starts with 0
    //             return;
    //         }
    //
    //         setHighlightedItem(item => item + 1);
    //
    //     }
    //
    // };

    const handleArrowMovement = (direction, event = false) => {


        const itemsCount = document.querySelectorAll(".tms-geosearch-city-list-item").length;
        const itemsIsHighlighted = document.querySelectorAll(".tms-city-is-highlighted").length;

        // if (itemsIsHighlighted <= 0 || itemsCount === 1) {
        //     setHighlightedItem(0);
        //     return;
        // }
        console.log(direction, "direction");

        if (direction === "up") { // up


            setHighlightedItem((item) => {
                if (item === 0) {
                    return itemsCount - 1;
                }
                return item - 1;
            });
        }

        if (direction === "down") { // up
            setHighlightedItem((item) => {
                if (item + 1 === itemsCount) {
                    return 0;
                }
                return item + 1;

            });
        }
    };

    const handleKeys = (event) => {
        if (event.keyCode === 38) {
            handleArrowMovement("up", event.target);
            event.preventDefault();

        }
        if (event.keyCode === 40) {
            handleArrowMovement("down", event.target);
            event.preventDefault();

        }

        if (event.key === "Enter") {
            const city = document.querySelector(".tms-city-is-highlighted").dataset.city;
            const country = document.querySelector(".tms-city-is-highlighted").dataset.country;
            handleGeocode({
                city, country

            });

            event.preventDefault();
        }

    };


    useEffect(() => {


        if (showResults) {
            window.addEventListener("keydown", handleKeys);
            window.addEventListener("keydown", handleHideDropdown);
            window.addEventListener("click", handleClickOutside);
        } else {
            window.removeEventListener("keydown", handleKeys);
            window.removeEventListener("keydown", handleHideDropdown);
            window.removeEventListener("click", handleClickOutside);
        }

        //TODO: is this event spamming? Check events in browser

        return () => {
            window.removeEventListener("keydown", handleKeys);
            window.removeEventListener("keydown", handleHideDropdown);
            window.removeEventListener("click", handleClickOutside);
        };

    }, [showResults]);

    const injectGoogleAutoComplete = () => {
        if (typeof google !== "object") {
            console.error("NO_GOOGLE_FOUND \n You tried to use a function that requires Google maps, but it was not found. Check your implementation or the key. Will ignore the Google maps functions like places autocomplete");
            return;
        }
        setInput(document.querySelector(
            ".tms-has-places-autocomplete input:not(.pac-target-input)"
        ));

    };
    useEffect(() => {
        if (autocomplete !== null) {
            autocomplete.addListener("place_changed", () => {
                inputProps.onChange(input, inputProps);
                props.setJobagentObject((oldJobagent) => {
                    return {
                        ...oldJobagent,
                        search: {
                            ...oldJobagent.search,
                            filter: {
                                ...oldJobagent.search.filter,
                                geoLocation: {
                                    lat: autocomplete.getPlace()
                                        .geometry
                                        .location
                                        .lat(),
                                    lng: autocomplete.getPlace()
                                        .geometry
                                        .location
                                        .lng(),
                                    radius: window.myTalentionConfig.jobagentRadius || 80,
                                    label: autocomplete.getPlace().name,
                                }
                            }
                        }
                    };
                });
            });

            input.addEventListener("keypress", (e) => {
                if (e.which === 13) {
                    e.preventDefault();
                }
            });

        }

    }, [autocomplete]);
    useEffect(() => {


        if (myTalentionConfig.geosearch?.active && myTalentionConfig?.geosearch?.version === 2) {
            console.log("talention geo");
        }
        if (inputProps.places) {
            const input = document.querySelector(".tms-has-places-autocomplete input");

            if (configObject.geosearch?.version === undefined && input && document.querySelector(".pac-container") === null) {


                injectGoogleAutoComplete(input);
            }

        }
    }, []);
    return (

        <ConditionalWrapper
            condition={inputProps.showLabel}
            wrapper={(children) => (
                <label htmlFor={inputProps.name} aria-labelledby={inputProps.name}
                       id={`tms-label--${inputProps.name}`}
                       className={["tms-input-label-wrapper", inputProps.required ? "tms-is-required" : null].join(" ")}>

                    {inputProps.label &&
                        (<div className={"tms-label"}>
                            <span>{inputProps.label}</span>
                            {inputProps.required ? null :
                                <span
                                    className={"tms-is-optional"}>{props.translations.optional}</span>}
                        </div>)
                    }

                    <div className={"tms-input-wrapper"}>{children}</div>
                </label>
            )}
        >
            <>
                {inputProps.placeholder && !inputProps.value ? <span
                    className={"tms-place-enter-value"}>{props.translations.pleaseEnter}</span> : null}
                <AutosizeInput
                    {...inputProps}
                    type={inputProps.type ? inputProps.type : "text"}
                    ref={ref}/>

                {listOfCities?.length && showResults ?
                    <div className={"tms-geosearch-city-list"} ref={filterElementWrapper}>
                        <ul>
                            {listOfCities?.map((response, key) => <li
                                onMouseUp={() => handleGeocode(response)}
                                data-city={response.city}
                                data-country={response.country}
                                // onMouseOver={() => setHighlightedItem(key)}
                                className={`tms-geosearch-city-list-item ${highlightedItem === key ? "tms-city-is-highlighted" : "not-hightlighted"}`}
                                key={key}><span><span
                                className={"tms-geosearch-city-list-item--city"}>
                                <HighlightSearchTerm title={response.city}
                                                     searchTerm={inputProps.registerObject?.customProperties?.[inputProps.name]?.length ? inputProps.registerObject.customProperties[inputProps.name] : inputProps.value}/></span>, <span
                                className={"tms-geosearch-city-list-item--country"}>{response.country}</span> </span>
                            </li>)}
                        </ul>
                        <div className={"tms-geosearch-powered-by"}>
                            Google Maps
                        </div>
                    </div>
                    : null}

            </>

        </ConditionalWrapper>

    );
});

export default Input;
